var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popover-container",
      class: {
        open: _vm.localShow,
        "align-right": _vm.alignRight,
        "align-left": _vm.alignLeft
      }
    },
    [
      _vm.hasTriggerSlot
        ? _c(
            "span",
            { staticClass: "trigger", on: { click: _vm.handleTriggerClick } },
            [_vm._t("trigger")],
            2
          )
        : _c("FontAwesomeIcon", {
            attrs: { icon: ["far", "plus-circle"] },
            on: { click: _vm.handleTriggerClick }
          }),
      _vm.localShow
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "on-clickaway",
                  rawName: "v-on-clickaway",
                  value: _vm.handleTriggerClick,
                  expression: "handleTriggerClick"
                }
              ],
              staticClass: "popover",
              style: {
                width: _vm.width,
                left: _vm.posX + "px",
                top: _vm.posY + "px"
              },
              on: { click: _vm.handleTriggerClick }
            },
            [_vm._t("content")],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }